import { render } from "./B2bTableOrdersEmit.vue?vue&type=template&id=7fd7aea6&scoped=true&lang=pug"
import script from "./B2bTableOrdersEmit.vue?vue&type=script&lang=js"
export * from "./B2bTableOrdersEmit.vue?vue&type=script&lang=js"

import "./B2bTableOrdersEmit.vue?vue&type=style&index=0&id=7fd7aea6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd7aea6"]])

export default __exports__